import axios, { type AxiosInstance, type AxiosRequestConfig } from "axios";

import { ENV } from "@/shared/config/env";
import type { UnifiedError } from "@/shared/types/api";

export interface ApiRuntimeContext {
  silent?: boolean;
  status?: number;
  reason?: string;
}

export interface ApiRuntimeStrategy {
  getToken?: () => string | null;
  getPrivacyToken?: () => string | null;
  getLanguage?: () => string | null;
  onUnauthorized?: () => void;
  onError?: (error: UnifiedError, context: ApiRuntimeContext) => void;
}

const defaultConfig: AxiosRequestConfig = {
  baseURL: ENV.apiBase,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    "x-requested-with": "XMLHttpRequest",
  },
  withCredentials: false,
};

let apiRuntime: ApiRuntimeStrategy = {};

export function createApiClient(config: AxiosRequestConfig = {}): AxiosInstance {
  return axios.create({ ...defaultConfig, ...config });
}

export function registerApiRuntime(strategy: ApiRuntimeStrategy): void {
  apiRuntime = strategy;
}

export function getApiRuntime(): ApiRuntimeStrategy {
  return apiRuntime;
}
